import { environment } from '../../../../environments/environment';
import { SQLService } from '../../../services/sql.service';
import { NewBackup } from '../../../models/backup';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'ng-cheques-new-mysql-backup',
  templateUrl: './new-mysql-backup.component.html',
  styleUrls: ['./new-mysql-backup.component.styl']
})
export class NewMySQLBackupComponent implements OnInit {
  constructor(
    public sql: SQLService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}
  _c=0;
  mysql = new NewBackup();
  currencies = Object.keys(environment.currencies);
  save() {
    this.sql.add("Backups",this.mysql);
    this.mysql = new NewBackup();
    this._c=0;
    this.end();
  }
  end() {
   if (this._c>0) {
      if (confirm(this.sql.word.Discard_Confirmation)) {
        this.mysql = new NewBackup();
        this.router.navigate(['folder','Settings','Backup']);
      }
    } else {
      this.router.navigate(['folder','Settings','Backup']);
    }
  }
  get_mysql_backup() {
    let ida = this.route.snapshot.paramMap.get("id");
    if(!ida) return;
    this.sql.view('Backups','backup_id',ida,(e)=>{
      var f = Object.entries(e[0]); let n=new NewBackup();
      for( let t of f) n[t[0] ]=t[1]; this.mysql = n;
    });
  }
  ngOnInit() {
    this.mysql.auto=true;
    this.get_mysql_backup();
  }
}